// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components-wpbbsa/form-item-insurance-personal/form-item-insurance-personal.component.scss
// module id = 928
// module chunks = 0